import styled from '@emotion/styled';
import React, { ReactElement } from 'react';
import {
  OL_COLOUR_MELON,
  OL_COLOUR_ORANGE_WARNING,
  OL_COLOUR_TOMAHTO,
} from '../Style/colours';

export type ChipVariant = 'default' | 'warning' | 'success' | 'error';

export interface ChipProps {
  variant: ChipVariant;
  label: string;
}

const Container = styled('div')({
  width: 83,
  height: 20,
  borderRadius: 4,
  backgroundColor: '#CACACA',
  color: 'white',
  textAlign: 'center',
  fontWeight: 'bold',
});

const SuccessStyleVariant = {
  backgroundColor: OL_COLOUR_MELON,
};

const ErrorStyleVariant = {
  backgroundColor: OL_COLOUR_TOMAHTO,
};

const WarningStyleVariant = {
  backgroundColor: OL_COLOUR_ORANGE_WARNING,
};

export const Chip = ({ variant, label }: ChipProps): ReactElement => {
  let styleVariant;

  switch (variant) {
    case 'success':
      styleVariant = SuccessStyleVariant;
      break;
    case 'error':
      styleVariant = ErrorStyleVariant;
      break;
    case 'warning':
      styleVariant = WarningStyleVariant;
      break;
    default:
  }

  const ContainerElement = styled(Container)(styleVariant);

  return <ContainerElement>{label}</ContainerElement>;
};
